import { render, staticRenderFns } from "./create_trucking_form.vue?vue&type=template&id=f7eefeba"
import script from "./create_trucking_form.vue?vue&type=script&lang=js"
export * from "./create_trucking_form.vue?vue&type=script&lang=js"
import style0 from "./create_trucking_form.vue?vue&type=style&index=0&id=f7eefeba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports